import O1HD, {modules} from "../../engines/gameEngine";
import {REWARD_TYPE} from "../../engines/services/userContent/userInterface";
import gameConfig from "../../engines/configs/gameConfig";
import data_control from "../../engines/libs/data_control";

const {ccclass, property} = cc._decorator;

@ccclass
export default class Diamond extends cc.Component {

    @property(cc.Label)
    lbDiamond: cc.Label = null;

    onLoad() {

    }

    start() {

    }

    OnBtnAddDiamonds() {
        modules().uiControlModule.showUserPropGet(REWARD_TYPE.DIAMOND, gameConfig.ADD_ONCE_COINS);
    }

    update(dt) {
        this.lbDiamond.string = data_control.getNumberFormat(O1HD.getServices().userSrv.getDiamonds(), 0);
    }
}
